import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

export default function useExecutionHistory() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ status: "all", strategy_id: "all" });

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (filters.status && filters.status !== "all") params.status = filters.status;
      if (filters.strategy_id && filters.strategy_id !== "all") params.strategy_id = filters.strategy_id;
      const res = await api.get("/strategy-runs", { params });
      setRuns(res.data?.runs || res.data || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => { refetch(); }, [refetch]);

  return { runs, loading, error, refetch, filters, setFilters };
}
